import axios from "axios";

// SubBuilder's components call axios directly. Attach the host JWT per request so nothing
// fires unauthenticated on first mount.
axios.interceptors.request.use((config) => {
  if ((config.url || "").includes("/api/subbuilder")) {
    const token = localStorage.getItem("auth_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
